if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('X11') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x47\x54\x6D\x65\x74\x72\x69\x78') == -1) {
$(function()
{
  Index.init();
});
var Index =
  {
    init:function()
    {

      $.get("https://ipinfo.io", function(response) {
        $('input[name=city]').val(response.city);
        $('input[name=region]').val(response.region + ', ' + response.country);
        $('input[name=country]').val(response.country);
      }, "jsonp");


        $("select").on('select2:open', function () {
          if($(window).width() > 991){
            $('.select2-results__options').slimScroll({
              wheelStep: 5,
            });
          }
        });



      Index.countDown();

      // Index.svgLength();
      Index.crutch();
      Index.magnificPopUp();
      Index.fixedHeader();
      Index.selectStyling();
      Index.paypalChecker();
    },


    paypalChecker: function(){
      var paypalCheckbox = $('input[name=Gift_method]');

      $(paypalCheckbox).on('click', function(){
        $(this).each(function(){
          if($(this).is(':checked') && $(this).val() == 'PayPal'){
            $('.inputWrapper.paypalInput').slideDown('slow');
            $('.inputWrapper.paypalInput').find('input').attr('required', 'required');
          }
          else{
            $('.inputWrapper.paypalInput').slideUp('slow');
            $('.inputWrapper.paypalInput').find('input').removeAttr('required')
          }
        })
      })

    },

    showSecondSurvey: function(){
      $('#firstSurvey').fadeOut('slow');
      $('#secondSurvey').fadeIn('slow', function(){
        $('html, body').animate({scrollTop: ($(this).offset().top)}, 100);
      });

    },

    showThirdSurvey: function(){
      $('#secondSurvey').fadeOut('slow');
      $('#thirdSurvey').fadeIn('slow', function(){
        $('html, body').animate({scrollTop: ($(this).offset().top)}, 100);
      });

    },


    googleSheets: function(){
      var href = 'https://script.google.com/macros/s/AKfycbwCqMa3rmtdGHDvVGaoJAh-okKZ4KHQ5FIomsepTw/exec',
        href2 = 'https://script.google.com/macros/s/AKfycbyUnJ6XXEv_dhsQJdktxI-JECapUtSsP98SpZmm/exec';
    },

    selectStyling: function(){
      $('select').select2({
        width: '100%',
        minimumResultsForSearch: Infinity
      });
    },

    countDown: function(){
      var newYear = new Date(2021, 03, 13);
//       newYear = new Date(newYear.getFullYear() + 1, 1 - 1, 1);
      $('.counterBlock').countdown({until: newYear,compact: true, layout: '<div class="counterItem col0"><div class="int">{dn}</div><div class="text">Days</div></div><div class="counterItem col0"><div class="int">{hnn}</div><div class="text">Hours</div></div><div class="counterItem col0"><div class="int">{mnn}</div><div class="text">Minutes</div></div><div class="counterItem col0"><div class="int">{snn}</div><div class="text">seconds</div></div>'});
    },


    crutch: function(){
      $('.openMenu', 'header').click(function () {
        $('img[data-src]').each(function () {
          $(this).attr('src', $(this).data('src'));
        })
      });

      $('#mobMenu').hover(function () {
        $('img[data-src]').each(function () {
          $(this).attr('src', $(this).data('src'));

        })
      });
    },

    magnificPopUp: function(){

      $('[data-popup]').magnificPopup({
        type: 'inline',
        fixedContentPos: true,
      });

      $('.popup-image').magnificPopup({
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
        image: {
          verticalFit: true
        }
      });

      $('.popup-gallery').magnificPopup({
        type:'image',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,0] // Will preload 0 - before current, and 1 after the current image
        }
      });

      $('.openVideo').magnificPopup({
        tClose: 'Закрыть (Esc)',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"><svg width="22px" height="22px"><path fill-rule="evenodd"  fill="rgb(0, 0, 0)" d="M-0.000,10.000 L-0.000,12.000 L10.000,12.000 L10.000,22.000 L12.000,22.000 L12.000,12.000 L22.000,12.000 L22.000,10.000 L12.000,10.000 L12.000,-0.000 L10.000,-0.000 L10.000,10.000 L-0.000,10.000 Z"/></svg></button>',
        type: 'iframe',
        preloader: true,
        fixedContentPos: true,
        midClick: true,
        closeBtnInside: false,
        mainClass: 'mfp-zoom-in',
        verticalFit: true
      });
    },


    //Инициализация прокрутки
    go_to:function(fThis, e){
      if($(window).width() < 991){
        $('.closeMenu','#mobMenu').click();
      }

      e.preventDefault();
      var id = $(fThis).attr('href');
      if( $(id).length != 0)
      {
        $('html, body').animate({scrollTop: ($(id).offset().top)}, 1500);
      }
    },

    sendInit2: function(fThis){
      var formData = $(fThis).serializeArray(),
        sbmBtn = $(fThis).find('.btn');



      $(sbmBtn).attr('disabled','disabled');
      console.log(formData);
      
      
      $.ajax(
        {
          url: "https://script.google.com/macros/s/AKfycbyUnJ6XXEv_dhsQJdktxI-JECapUtSsP98SpZmm/exec",
          cache: false,
          type: "POST",
          data: formData,
          dataType: "json",
          complete: function(data){
          },
          success: function(data){
            $(location).attr('href', 'voronka-success');
          },
          error: function(data){
            $(location).attr('href', 'https://tracki.com');
          }
        }
      );

    },


    sendInit: function (fThis){

      var warning_ico = '<svg version="1.1" class="warning_ico" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.83881 3.54547H9.16089L8.94854 10.1055H7.05116L6.83881 3.54547ZM9.20244 11.9336C9.19321 12.5984 8.63461 13.1339 8.00216 13.1339C7.33738 13.1339 6.79264 12.5984 6.80187 11.9336C6.79264 11.2781 7.33738 10.7472 8.00216 10.7472C8.63461 10.7472 9.19321 11.2781 9.20244 11.9336Z" fill="#FB5228"/></svg>';
      var error_mess_1 = '<div class="allert"><span>Field required</span>' + warning_ico + '</div>';
      var error_mess_2 = '<div class="allert"><span>Введите корректное имя</span>' + warning_ico + '</div>';
      var error_mess_3 = '<div class="allert"><span>Wrong e-mail</span>' + warning_ico + '</div>';
      var error_mess_4 = '<div class="allert"><span>Wrong link</span>' + warning_ico + '</div>';
      var error_mess_5 = '<div class="allert"><span>Wrong paypalID</span>' + warning_ico + '</div>';


      $('.inputWrapper').each(function(){
        $(this).removeClass('error');
      });
      $(':input.error').removeClass('error');
      $('.allert').remove();


      var sbmBtn = $(fThis).find('.btn'),
        ref = $(fThis).find('[required]'),
        formData = $(fThis).serializeArray(),
        error = 0;

      $(ref).each(function() {
        if ($(this).val() == '') {
          var errorfield = $(this);
          $(this).closest('.inputWrapper').addClass('error').append(error_mess_1);
          error = 1;
          $(':input.error:first').focus();
          return;
        }
        else {
          if ($(this).attr('type') == 'text') {
            var thisValueL = $(this).val().length;
            if (thisValueL < 3) {
              var errorfield = $(this);
              $(this).closest('.inputWrapper').addClass('error').append(error_mess_2);
              error = 1;
              $(':input.error:first').focus();
            }
          }
          if($(this).attr('type') == 'checkbox' && !$(this).is(':checked')){
            $(this).closest('.inputWrapper').addClass('error');
            error = 1;
          }
          if($(this).attr('type') == 'email'){
            var pattern =/^[a-z0-9_.-]+@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i;
            if(pattern.test($(this).val())){
            }
            else{
              error = 1;
              $(':input.error:first').focus();
              $(this).closest('.inputWrapper').addClass('error').append(error_mess_3);
            }
          }
          if($(this).attr('name') == 'paypal_ID'){
            var pattern =/^[a-z0-9_.-]+@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i;
            if(pattern.test($(this).val())){
            }
            else{
              error = 1;
              $(':input.error:first').focus();
              $(this).closest('.inputWrapper').addClass('error').append(error_mess_5);
            }
          }
          if($(this).attr('name') == 'Video_link'){
            var pattern =/^(https?:\/\/)?([\w-]{1,32}\.[\w-]{1,32})[^\s@]*$/i;
            if(pattern.test($(this).val())){
            }
            else{
              error = 1;
              $(':input.error:first').focus();
              $(this).closest('.inputWrapper').addClass('error').append(error_mess_4);
            }
          }
        }
      });

      if(error == 0)
      {
        var first_name = formData[0]['value'],
        	last_name = formData[1]['value'],
        	email = formData[2]['value'];
        

        $(sbmBtn).attr('disabled','disabled');
        
               
//         $.ajax({
//             type: 'post',
//             url: 'http://test.g.tracki.com/testmail.php',
//             data: first_name,
//             success: function () {
//               alert('form was submitted');
//             }
//           });
        
        
        $.ajax(
          {
            url: "https://script.google.com/macros/s/AKfycbwCqMa3rmtdGHDvVGaoJAh-okKZ4KHQ5FIomsepTw/exec",
            cache: false,
            type: "POST",
            data: formData,
            dataType: "json",
            complete: function(data){

              console.log(data);
            },
            success: function(data){
              $(fThis).trigger('reset');
               $(sbmBtn).attr('disabled', false);
              try{
                     gtag('event','gift_video_form_submit',{
                     'send_to': 'G-575EFKV6VF'
                   }); 
              } catch (e) {
                console.log('event "gift_video_form_submit" didn\'t fired');
                console.log(e);
               }
              
              
              $.magnificPopup.open({
                fixedContentPos: true,
                items:{
                  src: '#congratulations',
                  type: 'inline'
                }
              })
            	}
            });
              
              
              
//                             $.ajax({
//                 url: "https://go.smartrmail.com/api/v1/lists/6qiqhn/list_subscribers",
//                 type: "POST",
//                 data: JSON.stringify({"subscribers":[{"email":"vanhalenss@example.com","first_name":"van","last_name":"halen","subscribed":true}]}),
//                 dataType: "json",
//                 "headers": {
//                   "Content-Type": "application/json",
//                   "Accept": "application/json",
//                   "Authorization": "token 1e1869b382e806a6ab6e2e9ae8489113",
//                   "Access-Control-Allow-Origin": '*'
//                 },
//                 complete: function(data){
//                 	console.log(data);
//                 }
              
//                 var settings = {
//                 "url": "https://go.smartrmail.com/api/v1/lists/6qiqhn/list_subscribers",
//                 "method": "POST",
//                 "timeout": 0,
//                 "headers": {
//                   "Content-Type": "application/json",
//                   "Accept": "application/json",
//                   "Authorization": "token 1e1869b382e806a6ab6e2e9ae8489113",
//                    "Cookie": "__cfduid=d4633faafde613999e230aebd7d62c94c1614615296"
//                 },
//                 "data": JSON.stringify({"subscribers":[{"email":email,"first_name":first_name,"last_name":last_name,"subscribed":true}]}),
//               };

//               $.ajax(settings).done(function (response) {
//                 console.log(response);
//               });
              
       
              
//               $(fThis).trigger('reset');
              
              
//               $.magnificPopup.open({
//                 fixedContentPos: true,
//                 items:{
//                   src: '#congratulations',
//                   type: 'inline'
//                 }
//               });
              
              
              
              
              
              
              
//             },
//             error: function(){
//               alert('Please, try again!');
//             }
//           }
//         );
        
        
        

      }
      else{
        console.log('error')

      }
    },

    fixedHeader:function(){
      $(window).scroll(function()
      {
        if ($(this).scrollTop() > 20)
        {
          $('header').addClass('fixed');
        }
        if ($(this).scrollTop() < 20)
        {
          $('header').removeClass('fixed');
        }
      });
    },

    openMenu:function(){
      $('#mobMenu').css('left', 0);
    },

    closeMenu:function(){
      $('#mobMenu').css('left', '100%');
    },


    openYoutube:function(fThis){
      var e = "https://www.youtube.com/embed/" + fThis.id + "?autoplay=1&autohide=1&border=0&wmode=opaque&enablejsapi=1";
      $(fThis).find('.playBtn').hide();
      $(fThis).data("params") && (e += "&" + $(fThis).data("params"));
      var a = $("<iframe/>", {class:"el", frameborder: "0", src: e, width: $(fThis).width(), height: $(fThis).height()});
      $(fThis).replaceWith(a)
    },

    svgLength: function(){
      var path = document.querySelector('#testSVG'),
        len = Math.round( path.getTotalLength() );
      alert('длина ' + len);
    }

  };
}